/* ============================================================
   JGNT Recently Viewed - comportamiento

   Dos trabajos, en este orden:
     1. Registrar el producto de la pagina actual.
     2. Pintar los anteriores, sin incluir el actual.

   ------------------------------------------------------------
   POR QUE GUARDA UNA FOTO DE CADA PRODUCTO Y NO SOLO EL HANDLE

   Liquid corre en el servidor y no puede leer localStorage, asi
   que la lista tiene que armarse en el navegador. Habia dos
   caminos:

     a) guardar solo el handle y pedir /products/{handle}.js para
        cada uno al cargar
     b) guardar titulo, foto, precio y url en el momento de la
        visita

   Se eligio (b). Con (a) el carrusel no puede pintarse hasta que
   responden varias peticiones, asi que la seccion aparece vacia
   y luego brinca. Con (b) se pinta en el primer cuadro.

   EL COSTO, que conviene tener presente: el precio queda
   congelado al momento de la visita. Si cambias un precio, el
   cliente que ya vio ese producto vera el viejo en esta seccion
   hasta que vuelva a entrar a la ficha. Por eso la seccion trae
   el ajuste para ocultar precios: si te incomoda, se apagan.

   ------------------------------------------------------------
   SOBRE localStorage

   Es del navegador y del dispositivo, no de la cuenta: no se
   sincroniza entre telefono y computadora. Puede fallar en modo
   privado o con el almacenamiento lleno, por eso cada acceso va
   dentro de try. Si falla, la seccion simplemente no aparece.

   No se guarda nada que identifique a la persona, solo handles
   de productos publicos.
   ============================================================ */

(function () {
  if (window.jgntRecentlyViewedReady) return;
  window.jgntRecentlyViewedReady = true;

  var KEY = 'jgnt:recently-viewed';
  var CAP = 20;

  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function write(list) {
    try {
      window.localStorage.setItem(KEY, JSON.stringify(list.slice(0, CAP)));
    } catch (error) {
      /* Modo privado o almacenamiento lleno. Se ignora: la
         seccion se queda vacia y no pasa nada mas. */
    }
  }

  /* El producto actual se guarda al frente y se quita cualquier
     copia anterior, asi la lista queda por ultima visita y no
     por primera. */
  function record(product) {
    if (!product || !product.handle) return;

    var list = read().filter(function (item) {
      return item && item.handle !== product.handle;
    });

    list.unshift(product);
    write(list);
  }

  function card(item) {
    var link = document.createElement('a');
    link.className = 'jgnt-rv__card';
    link.href = item.url;

    if (item.image) {
      var img = document.createElement('img');
      img.className = 'jgnt-rv__media';
      img.src = item.image;
      img.alt = item.title || '';
      img.loading = 'lazy';
      link.appendChild(img);
    } else {
      var empty = document.createElement('span');
      empty.className = 'jgnt-rv__media jgnt-rv__media--empty';
      link.appendChild(empty);
    }

    var title = document.createElement('span');
    title.className = 'jgnt-rv__title';
    title.textContent = item.title || '';
    link.appendChild(title);

    if (item.price) {
      var price = document.createElement('span');
      price.className = 'jgnt-rv__price';
      /* El precio viene ya formateado desde Liquid, asi que no
         hay que interpretar el formato de moneda de la tienda. */
      price.innerHTML = item.price;
      link.appendChild(price);
    }

    return link;
  }

  function paint(root) {
    var track = root.querySelector('.jgnt-rv__track');
    if (!track) return;

    var exclude = root.getAttribute('data-jgnt-rv-current') || '';
    var limit = parseInt(root.getAttribute('data-jgnt-rv-limit'), 10) || 8;

    var items = read().filter(function (item) {
      return item && item.handle && item.handle !== exclude;
    });

    items = items.slice(0, limit);

    /* Sin historial no se deja un encabezado suelto: se esconde
       la seccion entera. */
    if (!items.length) {
      root.hidden = true;
      return;
    }

    track.innerHTML = '';
    for (var i = 0; i < items.length; i++) {
      track.appendChild(card(items[i]));
    }

    root.hidden = false;
  }

  function boot() {
    var roots = document.querySelectorAll('[data-jgnt-rv]');

    for (var i = 0; i < roots.length; i++) {
      var payload = roots[i].querySelector('[data-jgnt-rv-payload]');

      /* Primero registrar, despues pintar: asi el orden es el
         correcto desde la primera carga y el producto actual
         queda excluido por handle, no por posicion. */
      if (payload) {
        try {
          record(JSON.parse(payload.textContent));
        } catch (error) {
          /* JSON malformado: se sigue sin registrar. */
        }
      }

      paint(roots[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
